import { NavigationGuard } from 'vue-router';
import useI18nStore from '@/common/store/pinia/i18n';

export default function (pinia) {
  const store = useI18nStore(pinia);
  return (function loadLanguagesHandler(to, from, next) {
    if (!from.name) {
      store.loadLanguageList()
        .then(() => store.loadLanguage())
        .then(() => next())
        .catch((error) => {
          console.warn(`Can't load locale from cookie with error: ${error}`);
          next();
        });
    } else {
      next();
    }
  }) as NavigationGuard;
}
